import { render, staticRenderFns } from "./VoteBoardTimer.vue?vue&type=template&id=3c985b3e&scoped=true"
import script from "./VoteBoardTimer.vue?vue&type=script&lang=js"
export * from "./VoteBoardTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c985b3e",
  null
  
)

export default component.exports